import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { resetAnalyticsData, setAnalyticsCurrentView, updateAnalyticsAlarms, updateAnalyticsDuration } from "store/actions/analytics";
import { editAnalyticsAlarms, fetchCIPData } from "store/thunk/analytics";

import getLogger from "utils/logger.util";
import { timestampInDefaultFormat } from "utils/utils";
import { CHART_HEADER_ACTIONS } from "constants/chartConstant";

import ChartAlarms, { CHART_ALARMS_ACTION } from "components/ChartAlarms/ChartAlarms";
import { OverlayLoader } from "components/PageLoading";

import AnalyticsCIPOverlay from "./AnalyticsCIPOverlay/AnalyticsCIPOverlay";
import AnalyticsCIPCleaning from "./AnalyticsCIPCleaning";
import AnalyticsCleaningRequiredTable from "./AnalyticsCleaningRequiredTable";
import AnalyticsHeader from "./AnalyticsHeader";
import AnalyticsHistoricMembraneTable from "./AnalyticsHistoricMembraneTable";
import AnalyticsSideNav from "./AnalyticsSideNav";

import "./../Chart/index.scss";
import "./index.scss";

const Analytics = () => {
  const Logger = getLogger("Analytics");
  const dispatch = useDispatch();
  const { DurationRanges, PlotData, IsLoading, OrignialAlarms, CurrentView } = useSelector(state => state.analyticsData);
  const [xAxisRange, setXAxisRange] = useState([]);
  const [isEditAlarms, setIsEditAlarms] = useState(false);

  useEffect(() => {
    dispatch(updateAnalyticsDuration({ Duration: "Past 6 months" }));

    return () => {
      Logger.log("Analytics - destroying... reseting analytics state");
      dispatch(resetAnalyticsData());
    };
  }, []);
  useEffect(() => {
    if (isEditAlarms) {
      dispatch(updateAnalyticsAlarms({ isOpened: true }));
    }
  }, [isEditAlarms]);

  useEffect(() => {
    if (DurationRanges?.startTime && DurationRanges?.endTime) {
      dispatch(fetchCIPData());
      setXAxisRange([timestampInDefaultFormat(DurationRanges.startTime), timestampInDefaultFormat(DurationRanges.endTime)]);
    }
  }, [DurationRanges]);

  const onAlarmActions = params => {
    switch (params.action) {
      case CHART_ALARMS_ACTION.SAVE:
        dispatch(setAnalyticsCurrentView(CHART_HEADER_ACTIONS.NONE));
        dispatch(editAnalyticsAlarms(params.data));
        break;
      case CHART_ALARMS_ACTION.CANCEL:
        dispatch(setAnalyticsCurrentView(CHART_HEADER_ACTIONS.NONE));
        dispatch(updateAnalyticsAlarms({}));
        break;
      default:
        dispatch(updateAnalyticsAlarms({ updatedAlarms: params.data }));
    }
  };

  return (
    <div className="sideNav height--100">
      {IsLoading && <OverlayLoader />}
      <div className="sideNavMainContainer height--100">
        <AnalyticsSideNav />
        <div className="fullWidth chart-sidenav-container analytics-container">
          <AnalyticsHeader setIsEditAlarms={setIsEditAlarms} />
          {PlotData && !IsLoading && (
            <>
              <AnalyticsCIPOverlay xAxisRange={xAxisRange} setXAxisRange={setXAxisRange} />
              <AnalyticsCleaningRequiredTable analyticsRawData={PlotData} />
              <AnalyticsCIPCleaning analyticsRawData={PlotData} xAxisRange={xAxisRange} />
              <AnalyticsHistoricMembraneTable analyticsRawData={PlotData}/>
            </>
          )}
        </div>
      </div>
      {CurrentView === CHART_HEADER_ACTIONS.EDIT_ALARMS && <ChartAlarms OrignialAlarms={OrignialAlarms} onAlarmActions={onAlarmActions} />}
    </div>
  );
};

export default Analytics;
